import useGlobalParams from "../../hooks/useGlobalParams";
import useBusinesses from "../../hooks/useBusinesses";
import useCategories from "../../hooks/useCategories";
import useCurrentUser from "../../hooks/useCurrentUser";
import { userFriendlyName } from "../../utils/userUtils";
import { Trans as T } from 'react-i18next';

import BusinessDropdown from "../../common/Navigation/BusinessDropdown";
import PLink from "../../common/Navigation/PLink";

import './Dashboard.scss';

export default function Dashboard() {
  const { organizationId, businessId } = useGlobalParams();

  const { data: businesses } = useBusinesses({ organization_id: organizationId });
  const { data: categories } = useCategories({ businessId });

  const business = businesses?.find(business => business.id === businessId);

  const { currentUser } = useCurrentUser();

  return (
    <section className="__dashboard">

      <h2><T i18nKey='welcome-back'>Welcome back, {{ name: userFriendlyName(currentUser) }}</T></h2>

      <div className="current-business">
        <h3><T>Current business</T></h3>
        <BusinessDropdown organizationId={organizationId} businesses={businesses} selected={business} />
      </div>

      { categories && (
        <div className="business-categories">
          <div className="table-head">
            <div className="row-name"><T>Name</T></div>
            <div className="row-leads-count"><T>Details</T></div>
          </div>
          { categories?.map(category => (
            <PLink key={category.id} to={`/leads/${category.id}`} className="category-link">
              <div className="row-name">
              { category.name }
              </div>
              <div className="row-leads-count">
                <T i18nKey='x-leads' count={category.lead_count}>{{ count: category.lead_count }} leads</T>
              </div>
            </PLink>
          ))}
        </div>
      )}
    </section>
  )
}
